import actionTypes from '../actions/reduxActions/actionTypes';
import { getItem } from '../utils/storage';

const initialCollapsed = getItem(window.localStorage, 'sidebar_collapsed');
const initialState = {
    isCollapsed: initialCollapsed != null ? initialCollapsed : true,
};

const sidebar = (state = initialState, { type, payload }) => {

    switch (type) {

    case actionTypes.SIDEBAR_TOGGLE:

        return {
            isCollapsed: payload,
        };

    default:
        return state;
    }
};

export default sidebar;
